<div class="topbar" [class.topbar--with-back-link]="backLinkUrl">
    <app-back-link *ngIf="backLinkUrl" class="topbar__back-link" [link]="backLinkUrl"></app-back-link>
    <div class="topbar__page-title">
        <app-page-title></app-page-title>
    </div>
</div>
